import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './BookingNoteDisplay.module.css';

/**
 * BookingNoteDisplay — shows the booking note on the transaction page.
 *
 * Usage (in TransactionPanel):
 *   {features.bookingNotes && transaction.attributes.protectedData.bookingNote && (
 *     <BookingNoteDisplay note={transaction.attributes.protectedData.bookingNote} />
 *   )}
 */
const BookingNoteDisplay = ({ note, className }) => {
  if (!note || !note.trim()) return null;

  return (
    <div className={classNames(css.root, className)}>
      <p className={css.label}>
        <FormattedMessage id="BookingNoteDisplay.label" />
      </p>
      <p className={css.note}>{note}</p>
    </div>
  );
};

BookingNoteDisplay.defaultProps = { className: null };
BookingNoteDisplay.propTypes = { note: string.isRequired, className: string };

export default BookingNoteDisplay;
